import { Component, input, output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'order-reference-input',
  templateUrl: './order-reference-input.component.html',
})
export class OrderReferenceInputComponent {
  public reference = input<string>();
  public required = input(false);

  public referenceChange = output<string>();
}
